export default "__VITE_ASSET__BIXc8ECQ__"